// extracted by mini-css-extract-plugin
module.exports = {"space_right":"PromoForm--space_right--2itnO","form":"PromoForm--form--3aCmf","emailInput":"PromoForm--emailInput--2o-Dc","success":"PromoForm--success--3cQMQ"};